import { createAsyncThunk } from '@reduxjs/toolkit';

import { StateCityListProps } from 'entities/State';

import {
  getStateListService,
  getStateCityListService,
} from 'services/state.service';

export const getStateList = createAsyncThunk(
  'state/getStateList',
  async (_, thunkApi) => {
    try {
      const response = await getStateListService();

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getStateCityList = createAsyncThunk(
  'state/getStateCityList',
  async (data: StateCityListProps, thunkApi) => {
    try {
      const response = await getStateCityListService(data);

      return response.data;
    } catch (error: unknown) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
